import { regions } from './regions'
import countriesData from '@/data/countries.json'

const LOCALE_EXPIRY_DAYS = 1

// { "GB": "United Kingdom", "US": "United States", ... }
const isoToCountry = Object.fromEntries(countriesData.map((c) => [c.code, c.name]))

// { "United Kingdom": { locale, flag, country }, ... }
const countryToLocale = Object.fromEntries(
  regions.flatMap((r) => r.countries.map((c) => [c.name, { locale: c.locale, flag: c.flag, country: c.name }]))
)

async function detectCountryCode() {
  try {
    const res = await fetch('https://cloudflare.com/cdn-cgi/trace', { signal: AbortSignal.timeout(3000) })
    const text = await res.text()
    const match = text.match(/^loc=([A-Z]{2})$/m)
    return match ? match[1] : null
  } catch {
    return null
  }
}

export async function resolveGeoLocale() {
  const stored = localStorage.getItem('locale')
  const storedAt = localStorage.getItem('localeStoredAt')

  if (stored && storedAt) {
    const daysPassed = (Date.now() - Number(storedAt)) / (1000 * 60 * 60 * 24)
    if (daysPassed < LOCALE_EXPIRY_DAYS) {
      return null
    }
    localStorage.removeItem('locale')
    localStorage.removeItem('localeFlag')
    localStorage.removeItem('localeCountry')
    localStorage.removeItem('localeStoredAt')
  }

  const code = await detectCountryCode()
  if (!code) return null

  const countryName = isoToCountry[code]
  if (!countryName) return null

  return countryToLocale[countryName] ?? null
}
